// extracted by mini-css-extract-plugin
export default {"productDescription":"h_-z","featuredDescription":"i_-z","description":"j_-z","more":"k_-z","descriptionSku":"l_-z"};